export default __webpack_public_path__ + "assets/webgl/__scene.2780729c.glb";